import { lang } from "../components/generales/traduction"

const Perfil = ({ languaje, setLanguaje, server, dataGlobals, setNameState, mode, setMode }) => {

    var estado = ''
    if (dataGlobals.data.data !== undefined) {
        estado = dataGlobals.data.data.find(obj => obj.name === 'estado')
        setNameState(estado.value)
    }

    const modeAction = () => {
        setMode(mode === '' ? 'Dark' : '')
    }

    const changeLanguaje = () => {
        setLanguaje(languaje === 'es' ? 'en' : 'es')
    }

    return (
        <>
            <style>{`
        @keyframes pulse-dot {
          0%, 100% { opacity: .3; transform: scale(.95); }
          50% { opacity: 1; transform: scale(1.05); }
        }
        .inicio-dot {
          animation: pulse-dot 1.4s ease-in-out infinite;
        }
        .inicio-dot:nth-child(2) { animation-delay: .2s; }
        .inicio-dot:nth-child(3) { animation-delay: .4s; }
        .inicio-dot:nth-child(4) { animation-delay: .6s; }
        .inicio-dot:nth-child(5) { animation-delay: .8s; }
      `}</style>

            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f8fafc',
                fontFamily: "'DM Sans', system-ui, sans-serif",
                position: 'relative',
                overflow: 'hidden'
            }}>

                {/* Logo */}
                <div style={{ marginBottom: 30 }}>
                    <img
                        src="SaimonTech_logo.png"
                        alt="SaimonTECH"
                        style={{
                            height: 70,
                            width: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                </div>

                {/* Contenido dinámico */}
                {dataGlobals.loading ? (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: 14,
                            color: '#64748b',
                            marginBottom: 20,
                            fontWeight: 400
                        }}>
                            {lang[languaje]['CargandoDatos']}...
                        </div>
                        <div style={{
                            display: 'flex',
                            gap: 8,
                            justifyContent: 'center'
                        }}>
                            {[1, 2, 3, 4, 5].map(i => (
                                <div
                                    key={i}
                                    className="inicio-dot"
                                    style={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        background: '#1a56db'
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: 32,
                            fontWeight: 400,
                            color: '#94a3b8',
                            marginBottom: 8,
                            letterSpacing: '-.01em'
                        }}>
                            {lang[languaje]['bienvenido']}
                        </div>

                        {/* Estado si existe */}
                        {estado?.value && (
                            <div style={{
                                fontSize: 13,
                                color: '#64748b',
                                marginTop: 16
                            }}>
                                {estado.value}
                            </div>
                        )}
                    </div>
                )}

                {/* Toggle idioma — bottom right */}
                <div style={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    display: 'flex',
                    background: '#fff',
                    border: '1px solid #e2e8f0',
                    borderRadius: 8,
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,.06)'
                }}>
                    <div
                        onClick={() => setLanguaje('es')}
                        style={{
                            padding: '8px 16px',
                            fontSize: 12,
                            fontWeight: 500,
                            cursor: 'pointer',
                            background: languaje === 'es' ? '#0f2d5e' : '#fff',
                            color: languaje === 'es' ? '#fff' : '#64748b',
                            transition: 'all .2s',
                            userSelect: 'none'
                        }}
                    >
                        ES
                    </div>
                    <div
                        onClick={() => setLanguaje('en')}
                        style={{
                            padding: '8px 16px',
                            fontSize: 12,
                            fontWeight: 500,
                            cursor: 'pointer',
                            background: languaje === 'en' ? '#0f2d5e' : '#fff',
                            color: languaje === 'en' ? '#fff' : '#64748b',
                            transition: 'all .2s',
                            userSelect: 'none'
                        }}
                    >
                        EN
                    </div>
                </div>

                {/* Versión — bottom left */}
                <div style={{
                    position: 'fixed',
                    bottom: 24,
                    left: 24,
                    fontSize: 11,
                    color: '#94a3b8',
                    fontWeight: 400
                }}>
                    Version 1.3
                </div>

            </div>
        </>
    )
}

export default Perfil